// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9Ke73","home__main":"Home_home__main__44fcb"};